import React from "react";
import { useLang } from "../../context/LangContext";

export default function WhyDSCR() {
  const { c } = useLang();
  const w = c.why;
  return (
    <section className="section" style={{ background: "#0c0c0f" }}>
      <div className="container-x">
        <div className="reveal" style={{ maxWidth: 720, marginBottom: "3.5rem" }}>
          <span className="eyebrow">{w.eyebrow}</span>
          <h2 className="display" style={{ fontSize: "clamp(2.2rem,5vw,4rem)", margin: "1.2rem 0" }}>
            {w.title.pre}<span className="italic-gold">{w.title.em}</span>{w.title.post}
          </h2>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: "1.4rem" }}>
          {w.features.map((f, i) => (
            <div key={i} className="card reveal" style={{ padding: "2rem", borderLeft: "2px solid var(--gold)" }}>
              <h3 className="font-serif" style={{ fontSize: "1.4rem", marginBottom: "0.8rem", color: "var(--gold)" }}>{f.t}</h3>
              <p className="body-text" style={{ fontSize: "0.9rem" }}>{f.d}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
